import Splide from '@splidejs/splide';

const EL = '.js-simple-carousel';

document.querySelectorAll('.js-simple-carousel').forEach((carousel) => {
  const slider = new Splide(carousel, {
    arrows: false,
    pagination: false,
    gap: 40,
    fixedWidth: '400px',
    breakpoints: {
      1024: {
        fixedWidth: '300px',
        gap: 20,
      },
      767: {
        gap: 10,
      },
    },
  });

  slider.mount();

  const prevButton = carousel.querySelector('.splide__nav--prev');
  const nextButton = carousel.querySelector('.splide__nav--next');
  const counter = carousel.closest('.simple-carousel')?.querySelector('.simple-carousel__number');

  const updateControls = () => {
    const currentSlide = slider.index + 1;
    const totalSlides = slider.length;

    if (counter) counter.textContent = `${currentSlide} / ${totalSlides}`;

    if (prevButton) prevButton.disabled = slider.index === 0;
    if (nextButton) nextButton.disabled = slider.index === totalSlides - 1;
  };

  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => slider.go('<'));
    nextButton.addEventListener('click', () => slider.go('>'));
  }

  slider.on('moved', updateControls);

  updateControls();
});
